import { useState } from 'react';
import { LanguageInterfaceBoolean, LanguagesType } from 'App/i18n';
import { useGetAllLanguages } from 'domains/Auth/hooks';
import useGenerateProduct from '../../../hooks/useGenerateProduct/useGenerateProduct';

type FieldType = 'name' | 'description';

export type IsGeneratedAIType = Record<FieldType, LanguageInterfaceBoolean>;

export type SetIsFieldGeneratedAIType = (
  field: FieldType,
  language: LanguagesType,
  value: boolean,
) => void;

function useNameAndDescriptionAI() {
  const allLanguages = useGetAllLanguages();
  const { generatedAIName, generatedAIDescription } = useGenerateProduct();
  const initialIsGeneratedAI: IsGeneratedAIType = {
    name: allLanguages.reduce(
      (acc, language) => ({
        ...acc,
        [language]: generatedAIName[language] !== '',
      }),
      {},
    ),
    description: allLanguages.reduce(
      (acc, language) => ({
        ...acc,
        [language]: generatedAIDescription[language] !== '',
      }),
      {},
    ),
  };
  const [isGeneratedAI, setIsGeneratedAI] =
    useState<IsGeneratedAIType>(initialIsGeneratedAI);

  const setIsFieldGeneratedAI: SetIsFieldGeneratedAIType = (
    field,
    language,
    value,
  ) => {
    setIsGeneratedAI((prev) => ({
      ...prev,
      [field]: { ...prev[field], [language]: value },
    }));
  };

  return {
    isGeneratedAI,
    setIsFieldGeneratedAI,
  };
}

export default useNameAndDescriptionAI;
